import { render, staticRenderFns } from "./DomainProvision.vue?vue&type=template&id=06df2106&scoped=true&"
import script from "./DomainProvision.vue?vue&type=script&lang=js&"
export * from "./DomainProvision.vue?vue&type=script&lang=js&"
import style0 from "./DomainProvision.vue?vue&type=style&index=0&id=06df2106&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06df2106",
  null
  
)

export default component.exports